import Shape from "../../assets/Vector (22).png";
import Upload from "../../assets/upload-svgrepo-com (1) 1.png";
import { useState } from "react";
import "../../styles/Popup.css";
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import { useCreateEmployeeMutation } from "../../redux/features/careers/careersApiSlice";
import useInputField from "../../hooks/useInputField";
import { validCvExtension } from "../../data/rules";

function Popup() {
   // ################### RTK QUERY ###################
   const [createEmployee, { isLoading }] = useCreateEmployeeMutation();

   // ################### REACT HOOKS ###################
   const [cvFile, setCvFile] = useState(null);
   const [otherFile, setOtherFile] = useState(null);

   // ################### CUSTOM HOOKS ###################
   const [employeeInfo, focusedInput, handleEmployeeInfo, clearData] =
      useInputField({
         first_name: "",
         last_name: "",
         email: "",
         phone: "",
      });

   // ################### ROUTER HOOKS ###################
   let { careerIDinfo } = useParams();
   const navigate = useNavigate();

   // ################### VALIDATION ###################
   const validateEmployeeInfo = () => {
      const emailValidation = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

      if (!Object.values(employeeInfo).every((e) => e !== "")) {
         Swal.fire({
            icon: "error",
            text: "الرجاء ملىء جميع الحقول.",
         });
      } else if (!emailValidation.test(employeeInfo.email)) {
         Swal.fire({
            icon: "error",
            text: "الرجاء إدخال عنوان بريد الكتروني صحيح.",
         });
      } else if (+employeeInfo.phone <= 0 || employeeInfo.phone.length < 4) {
         Swal.fire({
            icon: "error",
            text: "الرجاء إدخال رقم هاتف صحيح.",
         });
      } else if (!cvFile) {
         Swal.fire({
            icon: "error",
            text: "الرجاء رفع ملف ال CV.",
         });
      } else {
         return true;
      }
   };

   // ################### HANDLER ###################
   const handleCreateEmployee = async (e) => {
      try {
         e.preventDefault();
         if (validateEmployeeInfo()) {
            const data = new FormData();
            data.append("career_id", careerIDinfo);
            data.append("first_name", employeeInfo.full_name);
            data.append("last_name", employeeInfo.full_address);
            data.append("email", employeeInfo.email);
            data.append("phone", employeeInfo.phone);
            data.append("file_one_path", cvFile);

            if (otherFile) data.append("file_two_path", otherFile);

            await createEmployee(data).unwrap();

            clearData();
            setCvFile(null);
            setOtherFile(null);

            navigate("/success");
         }
      } catch (err) {
         // TODO: Add alert from sweetAlert2 to show it when get error
         console.log(err);
      }
   };

   return (
      <div className="popup">
         <div className="head">
            <h5>طلب توظيف</h5>
         </div>
         <p>هل تناسبك هذه الوظيفة ؟ الرجاء ملئ المعلومات الخاصة بك</p>
         <div className="reply-time">
            <img src={Shape} alt="" />

            <span>متوسط وقت الرد على طلبك 72 ساعة</span>
         </div>
         <form onSubmit={handleCreateEmployee}>
            <div className="name">
               <input
                  type="text"
                  placeholder="الاسم الاول"
                  onChange={handleEmployeeInfo}
                  name="first_name"
                  value={employeeInfo.first_name}
                  ref={focusedInput}
               />
               <input
                  type="text"
                  placeholder="الاسم الثاني"
                  onChange={handleEmployeeInfo}
                  name="last_name"
                  value={employeeInfo.last_name}
               />
            </div>
            <input
               type="email"
               placeholder="الايميل*"
               onChange={handleEmployeeInfo}
               name="email"
               value={employeeInfo.email}
            />
            <input
               type="number"
               placeholder="رقم الهاتف*"
               onChange={handleEmployeeInfo}
               name="phone"
               value={employeeInfo.phone}
            />

            <h6>
               <span>تحميل السيرة الذاتية</span>
               <span>pdf,docx</span>
            </h6>
            <div>
               <div className="upload">
                  <img src={Upload} alt="" />
                  <p>قم بتحميل ملفك هنا</p>
                  <input
                     type="file"
                     multiple
                     onChange={(e) => {
                        const file = e.target.files[0];
                        if (validCvExtension.includes(file.type))
                           setCvFile(e.target.files[0]);
                        else
                           Swal.fire({
                              icon: "error",
                              title: "خطأ...",
                              text: "أنواع الملفات المسموحة (pdf, docs)",
                              width: 300,
                           });
                     }}
                     name="file_one_path"
                  />
               </div>
               {cvFile && (
                  <div className="maping">
                     <div className="active-file">
                        <p>Selected File: {cvFile.name}</p>
                        <button
                           onClick={() => setCvFile(null)}
                           className="remove"
                        >
                           x
                        </button>
                     </div>
                  </div>
               )}
            </div>
            <h6>
               <span>تحميل مرفقات اخرى</span>
               <span>pdf,docx</span>
            </h6>
            <div>
               <div className="upload">
                  <img src={Upload} alt="" />
                  <p>قم بتحميل ملفك هنا</p>
                  <input
                     type="file"
                     multiple
                     onChange={(e) => {
                        const file = e.target.files[0];
                        if (validCvExtension.includes(file.type))
                           setOtherFile(e.target.files[0]);
                        else
                           Swal.fire({
                              icon: "error",
                              title: "خطأ...",
                              text: "أنواع الملفات المسموحة (pdf, docs)",
                              width: 300,
                           });
                     }}
                     name="file_two_path"
                  />
               </div>
               {otherFile && (
                  <div className="maping">
                     <div className="active-file">
                        <p>Selected File: {otherFile.name}</p>
                        <button
                           onClick={() => setOtherFile(null)}
                           className="remove"
                        >
                           x
                        </button>
                     </div>
                  </div>
               )}
            </div>

            <div className="submit">
               {isLoading ? (
                  <input type="submit" disabled value="جاري الإرسال ..." />
               ) : (
                  <input type="submit" value="ارسال" />
               )}
            </div>
         </form>
      </div>
   );
}

export default Popup;
